module.exports = require("path");


//////////////////
// WEBPACK FOOTER
// external "path"
// module id = 1
// module chunks = 0